import { useCallback } from "react";
import {
  getBottomVisibleMessageId as resolveBottomVisibleMessageId,
  getTopVisibleMessageId as resolveTopVisibleMessageId,
} from "./scroll-controller-visible-message";
import type { ScrollControllerRefs } from "./use-scroll-controller-refs";

export interface ScrollVisibleMessageGetters {
  getTopVisibleMessageId: () => string | null;
  getBottomVisibleMessageId: () => string | null;
}

interface UseScrollVisibleMessageGettersInput {
  scrollRef: React.RefObject<HTMLDivElement | null>;
  refs: ScrollControllerRefs;
}

export function useScrollVisibleMessageGetters({
  scrollRef,
  refs,
}: UseScrollVisibleMessageGettersInput): ScrollVisibleMessageGetters {
  const getBottomVisibleMessageId = useCallback(() => {
    return resolveBottomVisibleMessageId({
      scrollRef,
      visibleMessageIdsRef: refs.visibleMessageIdsRef,
      messageElementsRef: refs.messageElementsRef,
    });
  }, [scrollRef, refs]);

  const getTopVisibleMessageId = useCallback(() => {
    return resolveTopVisibleMessageId({
      scrollRef,
      visibleMessageIdsRef: refs.visibleMessageIdsRef,
      messageElementsRef: refs.messageElementsRef,
    });
  }, [scrollRef, refs]);

  return {
    getTopVisibleMessageId,
    getBottomVisibleMessageId,
  };
}
